import { useMediaQuery, Box, Typography } from "@mui/material";
import React from "react";
import { Modal } from "pepsico-ds";
import "./LoginCardSet.css";
export default function DeniedModal({
  setModalOpen,
  openModal,
  deactivated = false,
}) {
  const isMobile = useMediaQuery("(max-width:1000px)");
  return (
    <Modal
      auxiliaryButtonProps={{}}
      className="modal1"
      linkProps={{}}
      onCloseModal={() => setModalOpen(false)}
      showAuxiliaryButton={false}
      showModal={openModal}
      showPrimaryButton={false}
      showTertiaryButton={false}
      showSecondaryButton={false}
      title=" "
      type={isMobile ? "L" : "S"}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
        }}
      >
        {deactivated ? (
          <Typography sx={{ textAlign: "center" }}>
            Your account has been deactivated. Please reach out to{" "}
            <a
              href="mailto:FritoLayAgSupport@pepsico.com?Subject=Account%20Deactivated"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none", color: "#005CBC" }}
            >
              SPA - Frito-Lay Agro Support
            </a>{" "}
            for assistance.
          </Typography>
        ) : (
          <>
            <Typography>{`Please reach out to `} &nbsp;</Typography>
            <a
              href="mailto:FritoLayAgSupport@pepsico.com?Subject=Customer%20Support%20Query"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none", color: "#005CBC" }}
            >
              SPA - Frito-Lay Agro Support &nbsp;
            </a>
            <Typography> with your request for access to this site</Typography>
          </>
        )}
      </Box>
    </Modal>
  );
}
